import React, { useState, useContext } from "react";
import {
    Avatar,
    Button,
    CssBaseline,
    TextField,
    Typography,
    Container,
    makeStyles,
    Modal,
    Theme,
} from "@material-ui/core";
import { SigninApi } from "api/SigninApi";
import "common.css";
import { SigninContext } from "pages/signin/SigninContext";

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        position: `absolute`,
        alignItems: `center`,
        backgroundColor: theme.palette.background.paper,
        border: `2px solid #000`,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: `100%`, // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    paperForModal: {
        position: `absolute`,
        alignItems: `center`,
        backgroundColor: `white`,
        border: `2px solid #000`,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

interface Props {
    isOpen: boolean;
    onClickCancel: VoidFunction;
    onClickSignin: VoidFunction;
    setDisplayStatus: any;
}

/**
 * ログインモーダル
 * @param props
 */
export const SigninModal: React.FC<Props> = (props) => {
    const { isOpen, onClickCancel, onClickSignin, setDisplayStatus } = props;
    const classes = useStyles();
    const [inputUserId, setInputUserId] = useState<string>(``); // フォームに入力されたユーザID
    const [inputPassword, setInputPassword] = useState<string>(``); // フォームに入力されたパスワード
    const [errorMessage, setErrorMessage] = useState<string>(``); // エラーメッセージ
    const { setSuccess } = useContext(SigninContext);

    const onClick = () => {
        // 認証処理
        const execute = async () => {
            const result = await SigninApi.signin(inputUserId, inputPassword);
            if (result?.status === 200) {
                onClickSignin();
                setDisplayStatus(`SingOut`);
                setSuccess(true);
            } else {
                setErrorMessage(`ユーザIDまたはパスワードに誤りがあります。`);
            }
        };

        execute();
    };

    /**
     * 入力フォームからカーソルが外れたタイミングで入力値をステートに保持
     * @param event
     */
    const handleBlur = (event: any) => {
        const id = event.target.id;
        const value = event.target.value;
        if (id === `userid`) {
            setInputUserId(value);
        } else if (id === `password`) {
            setInputPassword(value);
        }
    };

    const body = (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}></Avatar>
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>
                <div className={classes.form}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="userid"
                        label="User ID"
                        name="userid"
                        autoComplete="userid"
                        autoFocus
                        onBlur={handleBlur}
                        onChange={handleBlur}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        onBlur={handleBlur}
                        onChange={handleBlur}
                    />
                    <p className="error">{errorMessage}</p>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={onClick}
                    >
                        Sign In
                    </Button>
                </div>
            </div>
        </Container>
    );

    return (
        <Modal
            open={isOpen}
            onClose={() => {
                setErrorMessage(``);
                onClickCancel();
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            {body}
        </Modal>
    );
};
